import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useMediaAsset } from '~/composables';
import { handleImageSrc } from '~/helpers';

interface Props {
  slug?: string;
  link?: string;
  title?: string;
  image?: any;
  tags?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsItem',
  props: {
    slug: { default: '' },
    link: { default: '' },
    title: { default: '' },
    image: { default: '' },
    tags: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { slug: string, link: string, title: string, image: any, tags: any[] };



const { getAssetUrl } = useMediaAsset();

const imageSrc = computed(() => getAssetUrl(handleImageSrc(props.image)));

const isExternalLink = (link = '') => /^https?:/.test(link);

const getNewsItemUrl = (url?: string) => {
  if (url) return isExternalLink(url) ? url : `/${url.replace(/^\/+/, '')}`;
  return false;
};

return { __sfc: true,props, getAssetUrl, imageSrc, isExternalLink, getNewsItemUrl }
}

})